/* IMPORT */
import boolean from './boolean.js';
import effect from './effect.js';
import get from './get.js';
import Suspense from '../objects/suspense.js';
import { Stack } from './debugger.js';
/* MAIN */
const suspense = (when, fn, stack) => {
    const suspense = new Suspense();
    const condition = boolean(when);
    const toggle = () => suspense.toggle(get(condition));
    effect(toggle, { sync: true, stack: stack });
    return suspense.wrap(fn, undefined, undefined, stack);
};
/* EXPORT */
export default suspense;
